var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container py-5 h-100"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: 'Login'},"href":"#"}},[_c('span',{staticClass:"nav-text"},[_vm._v("Log in")])]),_vm._v(" or "),_c('router-link',{staticClass:"nav-link",attrs:{"to":{name: 'Register'},"href":"#"}},[_c('span',{staticClass:"nav-text"},[_vm._v("Register")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }